import { render, staticRenderFns } from "./ModalRedeemPointNewLayout.vue?vue&type=template&id=370fdb4f&scoped=true"
import script from "./ModalRedeemPointNewLayout.vue?vue&type=script&lang=js"
export * from "./ModalRedeemPointNewLayout.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeemPointNewLayout.vue?vue&type=style&index=0&id=370fdb4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fdb4f",
  null
  
)

export default component.exports